<template>
<div v-if="notification">
  <div class="basket__section basket__notifications"
       :class="classesFor(notification)"
       :key="notification.level">
    <svg role="presentation">
      <use xmlns:xlink="http://www.w3.org/1999/xlink"
           xlink:href="#svg--pricetag">
      </use>
    </svg>
    <div>
      <p><span v-html="notification.message"></span></p>
      <p v-if="notification.errors">
        <ul>
          <li v-for="error in errorsToMessages(notification.errors)" :key="error">
            {{ error }}
          </li>
        </ul>
      </p>
    </div>
  </div>
</div>
</template>
<script>
export default {
  methods: {
    classesFor(notification) {
      const className = {
        notice: 'notice',
        warning: 'alert',
        error: 'alert',
        success: 'success',
      }[notification.level];

      return className;
    },
    errorsToMessages(obj) {
      const messages = [];
      Object.keys(obj).forEach((key) => {
        obj[key].forEach((val) => {
          const msg = `${key} ${val}`;
          const cap = msg.charAt(0).toUpperCase();
          messages.push(`${cap}${msg.substring(1, msg.length)}.`);
        });
      });
      return messages;
    },
  },
  computed: {
    notification() {
      return this.$store.getters.notification;
    },
    shouldListErrors() {
      return true; // for now.
    },
  },
};
</script>
